module.exports = __webpack_public_path__ + "img/BS-PD.f0685d86.webp";